import { ShareWelcome } from "@/pages/settings/ShareWelcome";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui-kit/Card";

export function ShareWelcomeCard() {
  return (
    <Card data-testid="share-welcome-card">
      <CardHeader>
        <CardTitle>Share the welcome page</CardTitle>
        <CardDescription>
          The public client onboarding page (<code>/welcome</code>) needs no login. Copy the link to text a referred
          client, or print the QR code for in-person scanning.
        </CardDescription>
      </CardHeader>
      <CardContent><ShareWelcome /></CardContent>
    </Card>
  );
}
